import { renderCta } from '../../../util/cta/cta.template';
import Icon from '../../atoms/icon/Icon';
import classNames from 'classnames';
import styles from './Modal.module.scss';
import { type RefObject, useRef } from 'react';
import type { ModalCloseButtonProps, ModalCloseButtonRef } from './Modal.data';

const ModalCloseButton = ({ ref, onClose }: ModalCloseButtonProps) => {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<ModalCloseButtonRef | null>;

  return renderCta({
    innerTemplate: <Icon name="close" className={classNames(styles.icon)} />,
    props: {
      className: classNames(styles.closeButton),
      onClick: onClose,
      'aria-label': 'Click to close',
    },
    elementRef,
  });
};

export default ModalCloseButton;
